import { Box, ListItemButton } from "@mui/material";
import { Typography } from "@platform/design-system";

import type { Carrier } from "../types";

interface CarrierListItemProps {
  carrier: Carrier;
  selected: boolean;
  onSelect: (carrier: Carrier) => void;
}

export const CarrierListItem = ({
  carrier,
  selected,
  onSelect,
}: CarrierListItemProps): React.JSX.Element => (
  <ListItemButton
    data-testid={`carrier-list-item-${carrier.id}`}
    selected={selected}
    onClick={() => onSelect(carrier)}
  >
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
      <Box display="flex" alignItems="center" gap={1}>
        {carrier.isContracted && (
          <Box
            data-testid="carrier-contracted-indicator"
            role="img"
            aria-label="Contracted"
            width={8}
            height={8}
            borderRadius="50%"
            bgcolor="error.main"
          />
        )}
        <Typography variant="body-large">{carrier.name}</Typography>
      </Box>
      <Typography variant="body-medium" color="textSecondary">
        {carrier.repsCount} reps
      </Typography>
    </Box>
  </ListItemButton>
);
